/* eslint-disable no-console, import/prefer-default-export */
import { hasAssets } from './account-api';

const updateIconCss = (status) => {
  const icon = document.querySelector('.topbar-section .my-account-item');
  const visibleClass = 'items-added-to-swatchbook';

  if (!status) {
    icon.classList.remove(visibleClass);
  } else {
    icon.classList.add(visibleClass);
  }
};

const updateAccountIconStatus = () => {
  if (!window.isAuthenticated) {
    return;
  }
  hasAssets((data) => {
    if (data['has-assets']) {
      updateIconCss(true);
    } else {
      updateIconCss(false);
    }
  });
};

export {
  updateAccountIconStatus,
};
/* eslint-enable no-console, import/prefer-default-export */
